// ============================================================
// OwnerOnly — route/children guard koji propušta samo team-ownere.
//
// Čeka da se TeamContext učita (loading), zatim:
//   - ako je user owner tima (useIsTeamOwner) → prikazuje children
//   - inače → Redirect na redirectTo (default: team home /t/:slug)
//
// Primjer korištenja u ruti:
//   <Route path="/t/:slug/schedule" component={() => (
//     <TeamScope>
//       <OwnerOnly user={user}><Schedule user={user} /></OwnerOnly>
//     </TeamScope>
//   )} />
// ============================================================

import React from 'react';
import { Redirect } from 'react-router-dom';
import { useTeam } from '../contexts/TeamContext';
import { useIsTeamOwner, useCanEditTeam } from '../hooks/useIsTeamOwner';

// strict=true  → only the team owner (for settings, delete)
// strict=false → owner OR any manager (for schedule, matches)
const OwnerOnly = ({ user, redirectTo, strict = false, children }) => {
  const { loading, slug } = useTeam();
  const isOwner = useIsTeamOwner(user);
  const canEdit = useCanEditTeam(user);
  const hasAccess = strict ? isOwner : canEdit;

  if (loading) {
    return <div className="loading-screen">Učitavanje tima…</div>;
  }

  if (!hasAccess) {
    const fallback = redirectTo || (slug ? `/t/${slug}` : '/directory');
    return <Redirect to={fallback} />;
  }

  return <>{children}</>;
};

export default OwnerOnly;
